import Link from 'next/link'
import { useEffect, useState } from 'react'

export default function Hero() {
  const [count, setCount] = useState(0)

  useEffect(() => {
    fetch('/api/tokens/recent')
      .then(r => r.json())
      .then(d => setCount(d.tokens?.length || 0))
      .catch(() => {})
  }, [])

  return (
    <section style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center',
      justifyContent: 'center', textAlign: 'center',
      padding: '120px 24px 80px',
      background: 'radial-gradient(ellipse at top, rgba(124,58,237,0.15) 0%, transparent 60%)',
      position: 'relative', overflow: 'hidden'
    }}>
      {/* Background orbs */}
      <div style={{
        position: 'absolute', top: '20%', left: '10%',
        width: '300px', height: '300px', borderRadius: '50%',
        background: 'rgba(124,58,237,0.08)', filter: 'blur(80px)', pointerEvents: 'none'
      }}/>
      <div style={{
        position: 'absolute', bottom: '20%', right: '10%',
        width: '250px', height: '250px', borderRadius: '50%',
        background: 'rgba(6,182,212,0.08)', filter: 'blur(80px)', pointerEvents: 'none'
      }}/>

      <div style={{ maxWidth: '800px', position: 'relative' }}>
        {/* Badge */}
        <div style={{
          display: 'inline-flex', alignItems: 'center', gap: '8px',
          background: 'rgba(124,58,237,0.15)', border: '1px solid rgba(124,58,237,0.3)',
          borderRadius: '100px', padding: '8px 20px', marginBottom: '32px',
          fontSize: '13px', color: '#a78bfa'
        }}>
          <span style={{ width: '8px', height: '8px', borderRadius: '50%', background: '#7c3aed', display: 'inline-block', animation: 'pulse 2s infinite' }}/>
          Built on Vistara Diamond Chain — No Code Required
        </div>

        {/* Heading */}
        <h1 style={{ fontSize: 'clamp(36px, 6vw, 72px)', fontWeight: '800', lineHeight: '1.1', marginBottom: '24px' }}>
          Deploy Your Own{' '}
          <span className="gradient-text">ERC20 Token</span>
          <br />in 60 Seconds
        </h1>

        <p style={{ fontSize: '18px', color: '#94a3b8', lineHeight: '1.7', marginBottom: '40px', maxWidth: '600px', margin: '0 auto 40px' }}>
          No coding needed. Set name, symbol, supply — choose features like tax, cooldown, mint/burn — and deploy instantly on VDC Chain.
        </p>

        {/* CTA Buttons */}
        <div style={{ display: 'flex', gap: '16px', justifyContent: 'center', flexWrap: 'wrap', marginBottom: '60px' }}>
          <Link href="/create" style={{
            padding: '16px 36px', borderRadius: '14px', textDecoration: 'none',
            background: 'linear-gradient(135deg, #7c3aed, #06b6d4)',
            color: 'white', fontWeight: '700', fontSize: '16px',
            boxShadow: '0 8px 30px rgba(124,58,237,0.4)',
            transition: 'all 0.3s'
          }}>🚀 Create Token Now</Link>
          <Link href="/explore" style={{
            padding: '16px 36px', borderRadius: '14px', textDecoration: 'none',
            background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)',
            color: '#e2e8f0', fontWeight: '600', fontSize: '16px'
          }}>🔍 Explore Tokens</Link>
        </div>

        {/* Stats */}
        <div style={{ display: 'flex', gap: '40px', justifyContent: 'center', flexWrap: 'wrap' }}>
          {[
            { label: 'Tokens Deployed', value: '1000+' },
            { label: 'Deploy Fee', value: '1 VDC' },
            { label: 'Deploy Time', value: '< 60s' },
            { label: 'Chain ID', value: '882022' },
          ].map(stat => (
            <div key={stat.label} style={{ textAlign: 'center' }}>
              <div style={{ fontSize: '28px', fontWeight: '800', color: '#7c3aed' }}>{stat.value}</div>
              <div style={{ fontSize: '12px', color: '#64748b', marginTop: '4px' }}>{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
